import { Component, OnInit, Input, forwardRef, Output, EventEmitter } from '@angular/core';
import { AbstractCustomControlComponent } from '../abstract-custom-control/abstract-custom-control.component';
import { MedicalCenter, UserMDRef } from '../../../models/medical-center.model';
import { Observable } from 'rxjs';
import { startWith, switchMap, map, tap } from 'rxjs/operators';
import { MedicalCenterService } from '../../../services/medical-center.service';
import { HttpParams } from '@angular/common/http';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl } from '@angular/forms';


@Component({
  selector: 'app-medical-center-autocomplete',
  templateUrl: './medical-center-autocomplete.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MedicalCenterAutocompleteComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MedicalCenterAutocompleteComponent),
      multi: true
    }
  ]
})
export class MedicalCenterAutocompleteComponent extends AbstractCustomControlComponent implements OnInit {

  @Input() value: any;
  @Output() centerSelected = new EventEmitter<UserMDRef[]>();

  medicalCenters: Observable<MedicalCenter[]>;
  selectedCenter = new FormControl();

  constructor(private medicalCenterService: MedicalCenterService) {
    super();
  }

  ngOnInit() {
    this.medicalCenters = this.selectedCenter.valueChanges
    .pipe(
      startWith(''),
      tap(value => {
        if (this.selectedCenter.dirty && !value.id) {
          this.writeValue(null);
          this.centerSelected.emit([]);
        }
      }),
      switchMap(value => this.medicalCenterService.getMedicalCenterList(new HttpParams().set('page', '0').set('descr', value))),
      map(res => res.content)
    );

    if (this.value) {
      this.medicalCenterService.getMedicalCenter(this.value).subscribe(res => {
        this.selectedCenter.setValue(res);
        this.centerSelected.emit(res.users);
      });
    }
  }

  onSelectCenter(selected) {
    const medicalCenter = selected.option.value;
    this.writeValue(medicalCenter.id);
    this.centerSelected.emit(medicalCenter.users);
  }

  centerDisplayFn(medicalCenter: MedicalCenter): string {
    return medicalCenter && medicalCenter.descr ? medicalCenter.descr : '';
  }
}
